import type { FlexProps } from '@chakra-ui/react';
import { Flex, chakra } from '@chakra-ui/react';
import React from 'react';

import config from 'configs/app';

interface Props {
  className?: string;
  children: React.ReactNode;
  paddingTop?: FlexProps['paddingTop'];
  paddingBottom?: FlexProps['paddingBottom'];
  paddingX?: FlexProps['paddingX'];
}

const MainColumn = ({
  children,
  className,
  paddingTop = { base: '12px', lg: 6 }, // 12px is top padding of content area
  paddingBottom = 8,
  paddingX = { base: 3, lg: config.UI.navigation.layout === 'horizontal' ? 6 : 12 },
}: Props) => {
  return (
    <Flex
      className={ className }
      flexDir="column"
      flexGrow={ 1 }
      w={{ base: '100%', lg: config.UI.navigation.layout === 'horizontal' ? '100%' : 'auto' }}
      paddingX={ paddingX }
      paddingRight={{ '2xl': 6 }}
      paddingTop={ paddingTop }
      paddingBottom={ paddingBottom }
    >
      { children }
    </Flex>
  );
};

export default React.memo(chakra(MainColumn));
